module.exports = __webpack_public_path__ + "img/mediterranean-vegetable-lasagne.acddc3ec.jpg";